import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Navbar from "../../Navbar";
import { guestLoginUrl } from "../../BaseURL";
import "../../styles/public.css";

export default function GuestLogin() {
  const navigate = useNavigate();
  const location = useLocation();
  const next     = location.state?.next || "/reserve";

  const [form,    setForm]    = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [err,     setErr]     = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const res = await axios.post(guestLoginUrl, form);
      if (res.data?.success && res.data.guest) {
        localStorage.setItem("guest", JSON.stringify(res.data.guest));
        navigate(next, { replace: true });
      } else {
        setErr(res.data?.message || "Sign in failed.");
      }
    } catch (e) {
      setErr(e.response?.data?.message || "Sign in failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pp-root">
      <div className="pp-bg" />
      <Navbar />
      <div className="pp-content">
        <div className="pp-page-head">
          <div className="pp-eyebrow">Welcome Back</div>
          <h1 className="pp-h1"><em>Sign In</em></h1>
          <p className="pp-tag">
            Use the account you set up when you first reserved a room.
          </p>
        </div>

        <form className="pp-form-card" onSubmit={submit}>
          {err && <div className="pp-error">{err}</div>}

          <div className="pp-field">
            <label className="pp-label">Email</label>
            <input className="pp-input" type="email" required value={form.email}
                   onChange={(e) => setForm({ ...form, email: e.target.value })}
                   autoFocus />
          </div>

          <div className="pp-field">
            <label className="pp-label">Password</label>
            <input className="pp-input" type="password" required value={form.password}
                   onChange={(e) => setForm({ ...form, password: e.target.value })} />
          </div>

          <button type="submit" className="pp-btn" disabled={loading}>
            {loading ? "Signing in…" : "Sign In"}
          </button>

          <div className="pp-form-foot">
            New here? <Link to="/guest/signup" state={{ next }}>Create an account</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
